import { Component, Input, OnInit } from '@angular/core';
import { GoogleAnalyticsService } from 'src/app/main/services/google-analytics.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {
  imagesUrl = environment.imagesUrl + 'introduce';

  @Input('header1') header1 = '';
  @Input('header2') header2 = '';
  @Input('text1') text1 = '';
  @Input('text2') text2 = '';
  @Input('videoUrl') videoUrl = '';
  @Input('imageUrl') imageUrl = '';
  
  buttonText = 'ראיתי אתכם באתר ואשמח לקבל פרטים נוספים'
  constructor(private googleAnalyticsService:GoogleAnalyticsService) { }

  ngOnInit() {
  }

  joinUsClick(){
    this.googleAnalyticsService.eventEmitter('contact-button','home page','first slider contact button')
  }
}
